export default __webpack_public_path__ + "static/media/element_19.b7c118a0.webp";